var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge",class:{ 'badge-success' : this.status === 'ok', 'badge-danger': this.status === 'error' }},[_vm._v("\n  "+_vm._s(_vm.translateStatus(this.status))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }